<div class="analysis-options">
	<!-- Deselect All option-->
	<div class="pull-right text-16-bold deselect-label">
		<a
			class="cta-link-icon"
			*ngIf="getFilteredItems().length"
			(click)="deselectAll()"
			custom-tracking
			[track-event]="tealiumDeselectAllText"
			[attr.data-link-event]="tealiumDeselectAllText"
		>
			<icon type="times"></icon><span dcrHTMLKey="DESELECT_ALL_LABEL">Deselect All</span>
		</a>
	</div>

	<!-- Pills -->
	<div class="selected-items">
		<p class="item-type">
			<span class="item" *ngFor="let item of getFilteredItems(); trackByFields: 'id'">
				<span class="item-text">{{ getModelName(item) }}</span> <icon type="times" (click)="deselectItem(item)"></icon>
			</span>
		</p>
	</div>
</div>
